unit CategoryType;

interface

uses
  TypeType;

type
  TCategoryType = class
  private
    fCategoryKey: String;
    fName: String;
    fType: TTypeType;
    fActive: Boolean;
  published
    property CategoryKey: String read fCategoryKey;
    property Name: String read fName;
    property TypeType: TTypeType read fType;
    property Active: Boolean read fActive;
  end;

implementation

end.
